import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { logout } from "../../../services/authService";
import { toast } from "react-toastify";
import {
  LayoutDashboard,
  Home,
  Building2,
  LogOut,
  PlusCircle,
  MapPin,
  HardHat,
  Sparkles,
} from "lucide-react";
import "./Sidebar.css";

const SITE_NAME = "JMJK Properties";

const items = [
  { to: "/admin/dashboard", label: "Dashboard", icon: LayoutDashboard },
  { to: "/admin/property-list", label: "Properties", icon: Building2 },
  { to: "/admin/add-property", label: "Add Property", icon: PlusCircle },
];

// Optional masters – keep if you add these routes later
const masters = [
  { to: "/admin/cities", label: "Cities", icon: MapPin },
  { to: "/admin/developers", label: "Developers", icon: HardHat },
  { to: "/admin/amenities", label: "Amenities", icon: Sparkles },
];

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();

 const handleLogout = async () => {
  try {
    await logout();
    toast.success("Logged out successfully");
  } catch {
    toast.error("Logout failed");
  } finally {
    navigate("/admin", { replace: true });
  }
};

  const renderLink = (it) => {
    const active = location.pathname.startsWith(it.to);
    const Icon = it.icon;
    return (
      <Link
        key={it.to}
        to={it.to}
        className={`sb-link ${active ? "is-active" : ""}`}
      >
        <Icon className="sb-ico" />
        {it.label}
      </Link>
    );
  };

  return (
    <aside className="sb">
      <div className="sb-brand">
        <div className="sb-brand-name">{SITE_NAME}</div>
        <div className="sb-brand-sub">Admin Console</div>
      </div>

      <nav className="sb-nav">
        <div className="sb-section">Overview</div>
        {items.map(renderLink)}

        {masters.length > 0 && (
          <>
            <div className="sb-section">Master Data</div>
            {masters.map(renderLink)}
          </>
        )}
      </nav>

      <div className="sb-foot">
        <Link to="/" className="sb-foot-link">
          <Home className="sb-ico" />
          View site
        </Link>
        <button type="button" onClick={handleLogout} className="sb-foot-link">
          <LogOut className="sb-ico" />
          Sign out
        </button>
      </div>
    </aside>
  );
}